import React from 'react';
import { useSelector, shallowEqual } from 'react-redux';
import { StoreState } from '@mm/state/store-interfaces';
import {
  ConnectionVariableModel,
  ConnectionVariableKind,
} from '@mm/state/model/ConnectionVariableModel';
import { VariablesList } from '../VariablesList/VariablesList';
import { blankVariable } from '../helpers';
import { PrimaryButton } from '../../../../../../common/buttons/PrimaryButton/PrimaryButton';
import './EditResponseMapping.pcss';
import { PlusOutlined } from '@ant-design/icons';

type Props = {
  canBeTested: boolean;
  onClickTestConnection?: () => void;
  variablesToReceive: ConnectionVariableModel[];
  onVariablesChange: (variables: ConnectionVariableModel[]) => void;
  customOptionsPosition?: 'top' | 'bottom';
};

export const EditResponseMapping = ({
  variablesToReceive,
  onVariablesChange,
  canBeTested,
  onClickTestConnection,
  customOptionsPosition,
}: Props) => {
  const { attributes } = useSelector(
    (state: StoreState) => ({
      attributes: state.attribute.entities || [],
    }),
    shallowEqual,
  );

  const deleteVariable = (index: number) => {
    const nextVariables = [
      ...variablesToReceive.slice(0, index),
      ...variablesToReceive.slice(index + 1),
    ];

    onVariablesChange(nextVariables);
  };

  const updateVariable = (
    index: number,
    nextVariable: ConnectionVariableModel,
  ) => {
    const nextVariables = [
      ...variablesToReceive.slice(0, index),
      nextVariable,
      ...variablesToReceive.slice(index + 1),
    ];

    onVariablesChange(nextVariables);
  };

  const addVariable = () => {
    const nextVariables = [
      ...variablesToReceive,
      blankVariable(ConnectionVariableKind.toReceive),
    ];
    onVariablesChange(nextVariables);
  };

  return (
    <div className="edit-response-mapping">
      <VariablesList
        variables={variablesToReceive}
        attributes={attributes}
        onVariableDelete={deleteVariable}
        onVariableUpdate={updateVariable}
        customOptionsPosition={customOptionsPosition}
      />
      <div className="edit-connection-panel__action" onClick={addVariable}>
        <PlusOutlined
          className="edit-connection-panel__plus-icon"
          color="#2f54eb"
        />
        New Mapping
      </div>
      {onClickTestConnection && (
        <PrimaryButton
          className="edit-response-mapping__test-connection-btn"
          disabled={!canBeTested}
          onClick={onClickTestConnection}
        >
          Test Connection
        </PrimaryButton>
      )}
    </div>
  );
};
